



import xss from 'xss';
import * as linkify from 'linkifyjs';
import linkifyHtml from 'linkifyjs/html';
// import hashtag from 'linkifyjs/plugins/hashtag';

// hashtag(linkify);

export default {
    name: 'CoHtml',
    props: {
        html: {
            type: String,
            default: '',
        },
        // this replaces the linkifytiptap directive
        linkify: {
            type: Boolean,
            default: true,
        },
        // xssOptions is used to sanitize the html input
        xssOptions: {
            type: Object,
            default: () => ({
                // see https://jsxss.com/en/options.html
                //preserve span tags with attributes data-type="mention" and data-id=""
                whiteList: {
                    a: ['href', 'target', 'rel'],
                    b: [],
                    i: [],
                    em: [],
                    strong: [],
                    p: [],
                    br: [],
                    ul: [],
                    ol: [],
                    li: [],
                    span: ['data-type', 'data-id'], // allow data-type and data-id attributes on span tags to preserve mentions and hashtags
                    h1: [],
                    h2: [],
                    h3: [],
                    h4: [],
                    h5: [],
                    h6: [],
                    pre: [],
                    code: [],
                },
                // strip out all tags except those in the whiteList
                stripIgnoreTag: true,
                // remove the content of script tags
                stripIgnoreTagBody: ['script'],
            }),
        },
    },
    computed: {
        sanitizedHtml() {
            if (!this.html) return '';
            // Sanitize the HTML input
            let cleanHtml = xss(this.html, this.xssOptions);
            // If linkify is enabled, convert URLs, emails, and hashtags to links
            if (this.linkify) {
                // linkifyHtml will convert URLs and emails to links
                // and hashtags to spans with data-type="hashtag"
                cleanHtml = linkifyHtml(cleanHtml, {
                    defaultProtocol: 'https',
                    className: 'linkified-co-html',
                    ignoreTags: ['span'], // ignore span hashtags to prevent double linking of mentions and hashtags
                    validate: {
                        // prevent linking of mentions
                        mention(value) {
                            return false;
                        },
                    },
                });
            }
            return cleanHtml;
        },
    },
    mounted() {
        // add linkhandler to hashtags and mentions
        this.$nextTick(() => {
            this.addClickHandlers();
        });
    },
    methods: {
        // This method is used to handle the click event on links
        addClickHandlers() {
            const mentions = this.$el?.querySelectorAll ? this.$el.querySelectorAll('span[data-type="mention"]') : [];
            mentions.forEach((mention) => {
                if (!mention.dataset?.id) return;
                mention.addEventListener('click', () => {
                    this.$router?.push({
                        path: `/profile/${mention.dataset.id}`,
                    });
                });
            });
            const hashtags = this.$el.querySelectorAll('span[data-type*="hashtag"]');
            hashtags.forEach((hashtag) => {
                if (!hashtag.dataset?.id) return;
                hashtag.addEventListener('click', () => {
                    this.$router?.push({
                        path: `/search`,
                        query: {
                            term: hashtag.dataset.id,
                            type: 'hashtag',
                        },
                    });
                });
            });
        },
    },
};
